import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";
import { api, apiErr } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (er) { toast.error(apiErr(er)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-emerald-50 px-4">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-xl p-8 animate-fade-up">
        <Link to="/" className="flex items-center gap-2 justify-center mb-6"><div className="w-10 h-10 bg-emerald-600 rounded-xl flex items-center justify-center text-white font-extrabold text-lg">₹</div><span className="font-extrabold text-xl">Rani Super Market</span></Link>
        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <MailCheck size={48} className="text-emerald-600 mx-auto" />
            <h1 className="text-xl font-bold mt-3">Check your email</h1>
            <p className="text-slate-500 text-sm mt-1">If that email is registered, we've sent a password reset link. It expires in 1 hour.</p>
            <Link to="/login" className="inline-block mt-5 text-emerald-600 font-bold">Back to sign in</Link>
          </div>
        ) : (
          <>
            <h1 className="text-2xl font-bold text-center">Forgot password?</h1>
            <p className="text-center text-slate-500 text-sm mt-1">Enter your email and we'll send a reset link.</p>
            <form onSubmit={submit} className="mt-6 space-y-3">
              <input data-testid="forgot-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full border border-slate-200 rounded-xl px-4 py-3 text-sm" />
              <button data-testid="forgot-submit" disabled={busy} className="w-full py-3 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 text-white rounded-xl font-bold transition-colors">{busy ? "Sending…" : "Send reset link"}</button>
            </form>
            <p className="text-center text-sm text-slate-500 mt-5"><Link to="/login" className="text-emerald-600 font-bold">Back to sign in</Link></p>
          </>
        )}
      </div>
    </div>
  );
}
